import React from "react";
import GrDialog from "src/design-system/components/GrDialog";
import GrIconButton from "src/design-system/components/GrIconButton";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import { gr } from "src/design-system/tokens";

// Shared popup with a title and any content (e.g. Insert Link). Same props as before; GymRite dialog look.
export default function GeneralPopUpModel({
  open,
  title,
  setOpen,
  componentToPassDown,
}) {
  return (
    <GrDialog
      open={!!open}
      onClose={() => setOpen(false)}
      title={title}
      maxWidth={440}
    >
      <GrIconButton
        variant="ghost"
        size="sm"
        aria-label="Close"
        onClick={() => setOpen(false)}
        sx={{ position: "absolute", top: gr.space[4], right: gr.space[4] }}
      >
        <GrIcon icon={icons.close} />
      </GrIconButton>
      {componentToPassDown}
    </GrDialog>
  );
}
